import React from 'react';

import ActionButton from './components/ActionButton';
import Layout from './components/Layout';
import PortalCard from './components/PortalCard';
import { palette } from './styles';
import { onboardColors } from '../theme/onboardTokens';

interface Props {
  title: string;
  message: string;
  onBackToPortal?: () => void;
}

const PortalDone: React.FC<Props> = ({ title, message, onBackToPortal }) => (
  <Layout>
    <PortalCard variant="message">
      <div
        style={{
          width: 48,
          height: 48,
          margin: '0 auto 24px',
          borderRadius: '50%',
          background: palette.green,
          color: onboardColors.surface.white,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 28,
          fontWeight: 700
        }}
      >
        ✓
      </div>
      <h2 style={{ color: palette.headingNeutral, fontSize: 24, margin: '0 0 8px' }}>{title}</h2>
      <p style={{ color: palette.headingNeutral, fontSize: 16 }}>{message}</p>
      {onBackToPortal ? (
        <ActionButton
          label="Back to portal"
          onClick={onBackToPortal}
          style={{ marginTop: 16 }}
          variant="primary"
        />
      ) : null}
    </PortalCard>
  </Layout>
);

export default PortalDone;
